export enum PayType {
  HOURLY = 'Hourly',
  SALARY = 'Salary',
  DAILY = 'Daily',
}
